import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { HiSearchCircle } from 'react-icons/hi';
import styles from '../OrderList.module.css';

function DatePickerFilter({
    DateFrom,
    setDateFrom,
    DateTo,
    setDateTo,
    setDateSearch,
    setRefreshSe,
}) {
    return (
        <div className={styles['shopify-date-picker']}>
            <div className={styles['date-range-container']}>
                <DatePicker
                    selected={DateFrom}
                    onChange={(date) => setDateFrom(date)}
                    className={styles['shopify-date-input']}
                    placeholderText="Start date"
                />
                <span className={styles['date-separator']}>to</span>
                <DatePicker
                    selected={DateTo}
                    onChange={(date) => setDateTo(date)}
                    className={styles['shopify-date-input']}
                    placeholderText="End date"
                />
                <button
                    className={styles['shopify-search-btn']}
                    onClick={() => {
                        setDateSearch(true);
                        setRefreshSe((prev) => prev + 1);
                    }}
                    type="button"
                >
                    <HiSearchCircle />
                    Search
                </button>
            </div>
        </div>
    );
}

export default DatePickerFilter;
